export class LogoHelper {
  static companyLogoUrl(domainName) {
    return `https://logos.hunter.io/${domainName}`
  }
}
